import { Flex, FlexProps, Image, Text } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import iconSuccess from '@/assets/icon/success.svg';
import iconWarning from '@/assets/icon/warn.svg';
import iconError from '@/assets/icon/warn.svg';
import { InfoCardType } from './InfoCardTypes';

interface InfoCardProps extends FlexProps {
  type: InfoCardType;
  title: string;
  contents: React.ReactNode;
}

export default function InfoCard({
  type = InfoCardType.Success,
  title = '',
  contents = '',
  ...props
}: InfoCardProps) {
  const icon = useMemo(() => {
    switch (type) {
      case InfoCardType.Success:
        return iconSuccess;
      case InfoCardType.Warning:
        return iconWarning;
      case InfoCardType.Error:
        return iconError;
      default:
        return iconSuccess;
    }
  }, [type]);

  const styles = useMemo(() => {
    switch (type) {
      case InfoCardType.Success:
        return {
          border: '1px solid #0FA958',
          background: '#D6FFE9'
        };
      case InfoCardType.Warning:
        return {
          border: '1px solid #F5C853',
          background: '#FFEDBD'
        };
      case InfoCardType.Error:
        return {
          border: '1px solid #F5C853',
          background: '#FFEDBD'
        };
      default:
        return {
          border: '1px solid #0FA958',
          background: '#D6FFE9'
        };
    }
  }, [type]);

  return (
    <Flex
      borderRadius={'4px'}
      mx={'32px'}
      p={'15px'}
      style={{
        ...styles
      }}
      {...props}
    >
      <Image
        src={icon}
        alignSelf={'flex-start'}
        mr={'10px'}
        w={'28px'}
        h={'28px'}
        py={'4px'}
      ></Image>
      <Flex flexDir={'column'}>
        <Text fontSize={'16px'} fontWeight={600} lineHeight={1.75}>
          {title}
        </Text>
        <Flex fontSize={'14px'} fontWeight={400} mt={'5px'} display={'inline'}>
          {contents}
        </Flex>
      </Flex>
    </Flex>
  );
}
